import { render, staticRenderFns } from "./SampleInout.vue?vue&type=template&id=ec794b54"
import script from "./SampleInout.vue?vue&type=script&lang=js"
export * from "./SampleInout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports